module.exports = __webpack_public_path__ + "img/france-breast-cancer-female.ee8656c2.png";